/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_landing_features_ideintegration_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선호하는 로컬 개발 환경에서 EduSense의 강력한 AI 기능을 직접 활용하세요`)
};

const en_landing_features_ideintegration_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience EduSense's powerful AI features directly within your preferred local development environment`)
};

const ja_landing_features_ideintegration_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りのローカル開発環境でEduSenseの強力なAI機能を直接体験`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_features_ideintegration_description1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_features_ideintegration_description1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_features_ideintegration_description1", locale)
	if (locale === "ko") return ko_landing_features_ideintegration_description1(inputs)
	if (locale === "en") return en_landing_features_ideintegration_description1(inputs)
	return ja_landing_features_ideintegration_description1(inputs)
};
export { landing_features_ideintegration_description1 as "landing_features_ideIntegration_description" }